import React, { useCallback, useEffect, useState } from 'react'
import AccountingEntryService from '../../../services/accounting-entry/accountingEntry.service.js'
import CompanySelector from '../../../components/accounting-entry/CompanySelector.jsx'
import { Group, Stack } from '@mantine/core'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { accountingEntryMenu } from '../../../utils/constants/navlinks-Menu.js'

const AccountingEntryCommonHeader = () => {
  return <AppTabMenu options={accountingEntryMenu} />
}

export default AccountingEntryCommonHeader
